import { getCountryCodeFromLocale, getLanguageCodeFromLocale, isUSTerritory } from '../../utils'
import RegionalContentData from '../../constants/regionalConfig.json'

// TODO:  This will have to change to pull directly from Gringotts, or not at all (which Dave votes for)
// const getLatestRegionalContent = (configDataList) => {
//   let dynamicRegionalContent = null
//   if (configDataList) {
//     dynamicRegionalContent = configDataList.find((configData) => configData.configType === 'regionalContent')
//   }
//   return (dynamicRegionalContent && semver.lt(RegionalContentData.version, dynamicRegionalContent.version)) ? dynamicRegionalContent.config : RegionalContentData.config
// }

const regionalContentLookup = (pageLookup) => (dispatch, getState) => {
  // const { configContent } = getState().globalData
  const { locale, selectedLanguage } = getState().storedData
  let builtLocale = locale
  if (selectedLanguage) {
    builtLocale = `${selectedLanguage.split('_')[0] }_${ locale.split('_')[1]}`
  }
  const lookup = RegionalContentData.config // getLatestRegionalContent(configContent)
  if (Object.keys(lookup[pageLookup]).includes(builtLocale)) {
    return lookup[pageLookup][builtLocale]
  }
  let country = getCountryCodeFromLocale(locale)
  if (isUSTerritory(country)) {
    let usLocale = `${selectedLanguage ? selectedLanguage.split('_')[0] : getLanguageCodeFromLocale(locale)}_US`
    country = 'US'
    if (Object.keys(lookup[pageLookup]).includes(usLocale)) {
      return lookup[pageLookup][usLocale]
    }
    usLocale = `${getLanguageCodeFromLocale(locale) }_US`
    if (Object.keys(lookup[pageLookup]).includes(usLocale)) {
      return lookup[pageLookup][usLocale]
    }
  }
  if (!Object.keys(lookup[pageLookup]).includes(country)) {
    country = 'default'
  }
  return lookup[pageLookup][country]
}

const displayTelephoneLine = (locale) => !['FR'].includes(getCountryCodeFromLocale(locale))

export { regionalContentLookup, displayTelephoneLine }
